import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TipoDenunciaService } from 'src/app/dashboard/services/tipo-denuncia.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Denuncia } from 'src/app/dashboard/models/denuncia';

@Component({
  selector: 'app-tipo-denuncia',
  templateUrl: './tipo-denuncia.component.html',
  styleUrls: ['./tipo-denuncia.component.css']
})
export class TipoDenunciaComponent implements OnInit {
/** Society name displayed in the UI */
  sociedad: string;
    /** List of complaint types (denuncias) */

    denuncias: Denuncia[] = [];
     /** Complaint type selected for editing */
  selectedTipo: any = null;
  /** Current application language */
  language: string = 'es';
  showModal = false;

  constructor(
    private tipoDenunciaService: TipoDenunciaService,
    private auth: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  /**
   * Initializes language, society data and loads complaint types
   */  ngOnInit(): void {
    this.language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(this.language);
    this.sociedad = this.auth.getNameSociedad();
    this.loadTipos(this.language);
  }

  /**
   * Loads complaint types for the current society and language
   * @param language Current UI language
   */
    loadTipos(language: string) {
    this.tipoDenunciaService
      .searchComplaintByUserSociety(this.auth.getSociedad(), language)
      .subscribe((data: Denuncia[]) => {
             this.denuncias = (data || []).map((item: any) => ({
          ...item,
          is_visible: Number(item.is_visible)
        }));

      });
  }
 /** Controls the visibility of the create/edit modal */
  //showModal = false;

  /**
   * Opens modal in create mode
   */
  openCreate() {
    this.selectedTipo = null;
    this.showModal = true;
  }

  /**
   * Opens modal in edit mode
   * @param item Complaint type to edit
   */
  openEdit(item: any) {
    this.selectedTipo = item;
    this.showModal = true;
  }

  /**
   * Closes modal and resets state
   */
  closeModal() {
    this.showModal = false;
    this.selectedTipo = null;
  }

  /**
   * Callback executed after create or update
   */
  onSaved(res?: any) {
    this.closeModal();
    this.loadTipos(this.language);
  }


  /**
   * Deletes a complaint type by its identifier
   * @param id Complaint type ID
   */
deleteComplaintType(item: any) {
  // id_tp_denuncia is changed to id_tp_group to remove the type in all languages
  this.tipoDenunciaService.deleteComplaintTypeByUser(this.auth.getSociedad(), item.id_tp_denuncia)
    .subscribe({
      next: (res) => {
        if (res?.success) {
          this.toastr.success(
            this.translate.instant('texto_232'),
            this.translate.instant('texto_235')
          );
          this.loadTipos(this.language);
        } else {
          this.toastr.error(
            this.translate.instant('texto_233'),
            this.translate.instant('texto_813')
          );
        }
      },
      error: (error) => {
        if (error.error.code === 409) {
          this.toastr.error(
            this.translate.instant('texto_234'),
            this.translate.instant('texto_813')
          );
        } else {
          this.toastr.error(
            this.translate.instant('texto_233'),
            this.translate.instant('texto_813')
          );
        }
      }
    });
}

// Delete logically
toggleVisibility(item: any) {
  const nuevoEstado = item.is_visible === 1 ? 0 : 1;

  this.tipoDenunciaService.updateComplaintByUser(
    this.auth.getSociedad(),
    item.id_tp_denuncia,
    item.nombre,
    item.descripcion,
    this.auth.getIdUser(),
    item.tipo_receptor || '0',
    item.id_gestor || '',
    this.language || 'es',
    item.id_gestor_conflicto || '',
    item.orden || '',
    nuevoEstado
  ).subscribe({
    next: () => {
     // TOASTR SUCCESS
      this.loadTipos(this.language);
      this.toastr.success(
        this.translate.instant('texto_955'),
        this.translate.instant('texto_199')
      );
    },
    error: () => {
      //  TOASTR ERROR
      this.toastr.error(
        this.translate.instant('texto_956'),
        this.translate.instant('texto_813')
      );
    }
  });
}
}
